import styled from "styled-components"
import Summarize from "@mui/icons-material/Summarize"
import SearchIcon from '@mui/icons-material/Search';
export const HeaderDiv = styled.div`
background-color:#0072bc;
    position:sticky;
    padding: 5px 0px;
    display:flex;
    align-items:center;
`
export const SearchDiv = styled.div`
display:flex;
position:absolute;
margin:0 40% 0 40%;

`
export const Search = styled(SearchIcon)`
width:40px !important;
height:40px !important;
`
export const Logo = styled.div`
margin-left:30px;
`
export const Right = styled.div`
`